import { Avatar, Typography, theme } from 'antd'
import { DataList } from '@/Core/UI/DataList'

import { CiFileOn } from 'react-icons/ci'
import { favoritesManager, IFavorites } from '../Stores/FavoritesManager'

import { Button } from '@/Core/UI'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { RemoveFromFavoritesTask } from '../Tasks/RemoveFromFavoritesTask'

import './FavoritesListItem.css'
import { MdDeleteOutline } from 'react-icons/md'
import { GetResourceTask } from '@/Core/Tasks/Resources/GetResourceTask'
import { FiLink2 } from 'react-icons/fi'

interface FavoritesListItemProps {
    item: IFavorites
    onClick?: (item: IFavorites) => void
}
export const FavoritesListItem = ({ item, onClick }: FavoritesListItemProps) => {
    const { token } = theme.useToken()
    const { showError } = useNotification()

    const resource = GetResourceTask(item.entityCode)
    const IconComponent = resource?.pageConfig?.icon ?? <CiFileOn />

    return (
        <DataList.Item
            key={item.id}
            onClick={() => onClick?.(item)}
            style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                flexDirection: 'row',

                background: token.colorFillAlter,
                borderRadius: token.borderRadiusLG,
                padding: '12px 28px',

                cursor: 'pointer',
                transition: 'all 0.2s ease',
            }}
            className="favorites-item"
        >
            <Avatar
                size={38}
                style={{
                    backgroundColor: token.colorFillSecondary,
                    color: token.colorTextSecondary,
                    marginRight: 24,
                    flexShrink: 0,
                    transition: 'background-color 0.2s ease',
                }}
                icon={<IconComponent size={24} />}
            />

            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography.Title
                        level={5}
                        ellipsis
                        style={{
                            margin: 0,
                            fontWeight: 500,
                            fontSize: 15,
                            lineHeight: '18px',
                            maxWidth: '100%',
                        }}
                    >
                        {item.title}
                    </Typography.Title>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <FiLink2
                        style={{
                            color: token.colorTextTertiary,
                            fontSize: 14,
                            flexShrink: 0,
                        }}
                    />
                    <Typography.Text
                        ellipsis
                        style={{
                            fontSize: 14,
                            lineHeight: '17px',
                            color: token.colorTextSecondary,
                            maxWidth: '100%',
                        }}
                    >
                        {resource?.title ? `${resource.title}` : ''}
                    </Typography.Text>
                </div>
            </div>

            <Button
                type="text"
                className="delete-favorite-btn"
                icon={<MdDeleteOutline className="delete-favorite-icon" />}
                onClick={(e) => {
                    e.stopPropagation()
                    RemoveFromFavoritesTask({
                        uuid: item.uuid,
                        callBack: () => {
                            favoritesManager.removeFavoriteByUuid(item.uuid)
                        },

                        showError,
                    })
                }}
            />
        </DataList.Item>
    )
}
